export default __webpack_public_path__ + "static/media/FlexibleContent2.64284ff0.jpg";